@if (mapsReady$ | async) {
  <span class="rma-address-autocomplete">
    <mat-form-field class="w-full" subscriptSizing="dynamic" appearance="outline">
      @let label = this.label();
      <mat-label>{{ (label | isTranslationObject) ? (label.key | transloco) : label }}</mat-label>
      @if (prefix()) {
        <rma-icon class="mr-2" glyph="place" matPrefix />
      }
      <input
        type="text"
        [formControl]="inputControl"
        [matAutocomplete]="auto"
        [required]="required()"
        [placeholder]="placeholder()"
        [cdkTrapFocusAutoCapture]="autoFocus()"
        matInput
        autocomplete="street-address"
        cdkTrapFocus
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
        @for (option of options$ | async; track option) {
          <mat-option [value]="option">
            <div class="flex items-center">
              @if (prefix()) {
                <rma-icon glyph="place" matPrefix />
              }

              <span class="ml-2">{{ option.text.text }}</span>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error [required]="'form.error.full-address' | transloco" />
      @if (!hideHint()) {
        <mat-hint [class.hidden]="disable()">{{ 'form.placeholder.example-full-address' | transloco }}</mat-hint>
      }
    </mat-form-field>
  </span>
}
